import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const ReferencePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: ${token('space.025', '2px')} ${token('space.300', '24px')};
`;

export const ReferenceOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${token('space.025', '2px')};

  margin-bottom: ${token('space.050', '4px')};
`;

export const ReferenceOptionHeader = styled.span<{ isSubtle?: boolean }>`
  font: ${token('font.heading.xxsmall')};
  color: ${(props) =>
    props.isSubtle ? token('color.text.disabled', '#8993A5') : colors.N200};
`;

export const OptionGroup = styled.div`
  margin-bottom: ${token('space.300', '24px')};
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${token('space.100', '8px')};
`;
